import { Tooltip } from "antd";

export const formatCurrency = (val,round=false) => {
  val = Number(val || 0);
  if (round) {
    val = Math.round(val);
  }
  return val.toLocaleString("en-IN", {
    minimumFractionDigits: round ? 0 : 2 ,
    maximumFractionDigits: round ? 0 : 2,
  });
};

export const renderWithEllipsis = (
  text,
  { width = 180, lines = 1 } = {},
) => {
  if (!text) return <span style={{ color: "#aaa" }}>—</span>;

  return (
    <Tooltip title={text}>
      <div
        style={{
          width,
          overflow: "hidden",
          textOverflow: "ellipsis",

          ...(lines === 1
            ? { whiteSpace: "nowrap" }
            : {
                display: "-webkit-box",
                WebkitLineClamp: lines,
                WebkitBoxOrient: "vertical",
                whiteSpace: "normal",
              }),
        }}
      >
        {text}
      </div>
    </Tooltip>
  );
};
